import React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { Grid } from "@mui/material";
import "./collection.css";

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}
function CollectionGallery() {
  const itemData = [
    {
      img: "./Assets/col_g_1.png",
      rows: 3,
      cols: 3,
    },
    {
      img: "./Assets/col_g_2.png",
      cols: 1,
      rows: 1,
    },
    {
      img: "./Assets/col_g_3.png",
      rows: 1,
      cols: 1,
    },
    {
      img: "./Assets/col_g_4.png",
      rows: 1,
      cols: 1,
    },
  ];
  const itemDataTwo = [
    {
      img: "./Assets/col_g_8.png",
      rows: 3,
      cols: 3,
    },
    {
      img: "./Assets/col_g_5.png",
      cols: 1,
      rows: 1,
    },
    {
      img: "./Assets/col_g_6.png",
      rows: 1,
      cols: 1,
    },
    {
      img: "./Assets/col_g_7.png",
      rows: 1,
      cols: 1,
    },
  ];
  const itemDataThree = [
    {
      img: "./Assets/col_g_9.png",
      rows: 3,
      cols: 3,
    },
    {
      img: "./Assets/col_g_10.png",
      cols: 1,
      rows: 1,
    },
    {
      img: "./Assets/col_g_11.png",
      rows: 1,
      cols: 1,
    },
    {
      img: "./Assets/col_g_12.png",
      rows: 1,
      cols: 1,
    },
  ];
  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item xs={11} sm={8} md={4} lg={4}>
          <div className="collection_card">
            <ImageList variant="quilted" cols={4} gap={10}>
              {itemData.map((item) => (
                <ImageListItem
                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img
                    {...srcset(item.img, 121, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                    className="round_img"
                  />
                </ImageListItem>
              ))}
            </ImageList>
            <div className="col_sep"></div>
            <Grid container justifyContent="space-between">
              <Grid item lg={7}>
                <p className="coll_card_p">Creative Art Collection</p>
              </Grid>
              <Grid item lg={2}>
                <p className="item_p">5 items</p>
              </Grid>
            </Grid>
            <div className="col_card_like">
              <img src="./Assets/Heart.png" alt="" />
              <span className="k_span">2.1 K</span>
            </div>
            <div className="last_col_grid">
              <img src="./Assets/collect_id.png" alt="" />
              <span className="last_col_id">@ Aleena Jackie</span>
            </div>
          </div>
        </Grid>
        <Grid item xs={11} sm={8} md={4} lg={4}>
          <div className="collection_card">
            <ImageList variant="quilted" cols={4} gap={10}>
              {itemDataTwo.map((item) => (
                <ImageListItem
                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img
                    {...srcset(item.img, 121, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                    className="round_img"
                  />
                </ImageListItem>
              ))}
            </ImageList>
            <div className="col_sep"></div>
            <Grid container justifyContent="space-between">
              <Grid item lg={7}>
                <p className="coll_card_p">Creative Art Collection</p>
              </Grid>
              <Grid item lg={2}>
                <p className="item_p">5 items</p>
              </Grid>
            </Grid>
            <div className="col_card_like">
              <img src="./Assets/Heart.png" alt="" />
              <span className="k_span">2.1 K</span>
            </div>
            <div className="last_col_grid">
              <img src="./Assets/collect_id.png" alt="" />
              <span className="last_col_id">@ Aleena Jackie</span>
            </div>
          </div>
        </Grid>
        <Grid item xs={11} sm={8} md={4} lg={4}>
          <div className="collection_card">
            <ImageList variant="quilted" cols={4} gap={10}>
              {itemDataThree.map((item) => (
                <ImageListItem
                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img
                    {...srcset(item.img, 121, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                    className="round_img"
                  />
                </ImageListItem>
              ))}
            </ImageList>
            <div className="col_sep"></div>
            <Grid container justifyContent="space-between">
              <Grid item lg={7}>
                <p className="coll_card_p">Creative Art Collection</p>
              </Grid>
              <Grid item lg={2}>
                <p className="item_p">5 items</p>
              </Grid>
            </Grid>
            <div className="col_card_like">
              <img src="./Assets/Heart.png" alt="" />
              <span className="k_span">2.1 K</span>
            </div>
            <div className="last_col_grid">
              <img src="./Assets/collect_id.png" alt="" />
              <span className="last_col_id">@ Aleena Jackie</span>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default CollectionGallery;
